class BodyPillowCaseBlock extends HTMLElement {
  constructor() {
    super();
    this.cartDrawer = document.querySelector("cart-drawer");
    this.cartCountBubble = document.querySelector("#cart-icon-bubble");
  }

  connectedCallback() {
    this.loadItems();
    this.loadEventListeners();
  }

  loadItems() {
    this.size = this.querySelector("#pillow-case-size-selector");
    this.sizeLabel = this.size.querySelector(
      "#pillow-case-size-selector-label"
    );
    this.color = this.querySelector("#pillow-case-color-selector");
    this.colorLabel = this.querySelector("#pillow-case-color-selector-label");
    this.atcBtn = this.querySelector("#body-pillow-case-block--atc");
    this.price = this.atcBtn.querySelector(
      "#body-pillow-case-block--atc-price"
    );
  }

  loadEventListeners() {
    this.size.addEventListener("input", this.sizeEventHandler.bind(this));
    this.color.addEventListener("input", this.colorEventHandler.bind(this));
    // this.color.addEventListener(
    //   "mouseover",
    //   this.colorHoverEventHandler.bind(this)
    // );
    this.atcBtn.addEventListener("click", this.atcBtnEventHandler.bind(this));
  }

  // colorHoverEventHandler(event) {
  //   const label = event.target.closest("label");
  //   const inputId = label.getAttribute("for");
  //   const radioBtn = this.querySelector(`input[type="radio"]#${inputId}`);
  //   const handle = radioBtn.value;
  //   const color = radioBtn.dataset.color;
  //   this.colorLabel.innerHTML = color;
  //   this.dispatchColorEvent(handle);
  //   this.updatePrice(radioBtn, this.getActiveSize());
  // }

  sizeEventHandler(event) {
    const size = event.target.value;
    this.sizeLabel.innerHTML = size;
    this.filterColorsBySize(size);
  }

  colorEventHandler(event) {
    // const caseUrl = event.target.dataset.caseUrl;
    // window.location.href = caseUrl;
    const handle = event.target.value;
    const color = event.target.dataset.color;
    this.colorLabel.innerHTML = color;
    this.dispatchColorEvent(handle);
    this.updatePrice(event.target, this.getActiveSize());
  }

  filterColorsBySize(size) {
    this.color.querySelectorAll(`input[type="radio"]`).forEach((item) => {
      let { availableSizes } = item.dataset;
      item.disabled = !availableSizes.includes(size);
    });

    let checkedColor = this.color.querySelector(`input[type="radio"]:checked`);

    if (checkedColor.disabled) {
      checkedColor.checked = false;
      let newColor = this.color.querySelector(
        `input[type="radio"]:not(disabled)`
      );
      newColor.checked = true;
      this.dispatchColorEvent(newColor.value);
      this.colorLabel.innerHTML = newColor.dataset.color;
      this.updatePrice(newColor, size);
      return;
    }
    this.updatePrice(checkedColor, size);
  }

  dispatchColorEvent(handle) {
    let colorEvent = new CustomEvent("body-pillow-case::product-change", {
      detail: {
        handle,
      },
    });
    document.dispatchEvent(colorEvent);
  }

  atcBtnEventHandler(event) {
    const btn = event.target.closest("button");
    if (!btn) return;

    const activeSize = this.size.querySelector(`input:checked`).value;
    const activeColor = this.color.querySelector(`input:checked`);

    const variants = activeColor.dataset.variants.split("::");
    const [_, variantId] = variants
      .find((item) => item.includes(activeSize))
      .split(":");

    this.addToCart(variantId);
  }

  updatePrice(checkedColor, size) {
    const variant = checkedColor.dataset.variants
      .split("::")
      .find((item) => item.includes(size))
      .split(":");

    const price = variant.at(-2);
    const comparePrice = variant.at(-1);

    if (comparePrice !== "00") {
      this.price.innerHTML = `${price} <s>${comparePrice}</s>`;
    } else {
      this.price.innerHTML = `${price}`;
    }
  }

  getActiveSize() {
    return this.size.querySelector("input:checked").value;
  }

  async addToCart(variantId) {
    this.atcBtn.disabled = true;
    const formData = {
      items: [
        {
          id: variantId,
          quantity: 1,
        },
      ],
    };
    try {
      await fetch(window.Shopify.routes.root + "cart/add.js", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(formData),
      });
    } catch (error) {
      console.log(`Template Body Pillow Case | ${error}`);
    } finally {
      this.openAndPopulateCart();
      this.atcBtn.disabled = false;
    }
  }

  async openAndPopulateCart() {
    // Fetch the updated cart drawer content from the server
    const response = await fetch("/cart");
    const responseText = await response.text();

    // Parse the fetched HTML response into a DOM document
    const newCartMarkup = new DOMParser().parseFromString(
      responseText,
      "text/html"
    );

    // Update cart icon bubble
    const newCartIconBubbleMarkup =
      newCartMarkup.querySelector("#cart-icon-bubble");
    this.cartCountBubble.innerHTML = newCartIconBubbleMarkup.innerHTML;

    // Remove empty class
    this.cartDrawer.classList.remove("is-empty");

    // Get new cart drawer markup
    const newCartDrawerMarkup = newCartMarkup.querySelector("#CartDrawer");

    // Replace markup
    this.cartDrawer
      .querySelector("#CartDrawer")
      .replaceWith(newCartDrawerMarkup);

    // Open cart
    this.cartDrawer.open();

    this.cartDrawer.hideInstallmentsCTA();
  }

  disconnectedCallback() {}
}
customElements.define("body-pillow-case-block", BodyPillowCaseBlock);
